export default {
  general: {
    labels: {
      status: 'Status',
      actions: 'Ações',
      copied: 'Copiado',
      error: 'Erro',
      standard: 'Padrão',
      step: 'Passo',
      steps: 'Passos',
      times: 'vez(es)',
      table: 'Tabela',
      exporting: 'Exportando',
      your: 'Sua',
      in: 'em',
      date: 'DATA',
      box_name: 'Nome do Formulário de Pesquisa',
      new_box: 'Novo Formulário de Pesquisa',
      next: 'PRÓXIMO',
      edition: 'Edição',
      editing: 'Editando',
      description: 'Descrição',
      title: 'Título',
      days: 'Dias',
      configurations: 'Configurações',
      and: 'e',
      seconds: 'Segundos',
      homepage: 'Página Inicial',
      hotmart_logo: 'Logo da Hotmart',
      themes: 'Modelos',
      saving: 'Salvando',
      jump: 'Salto',
      destinations: 'Destinos',
      first: 'Primeiro',
      last: 'Último',
      to: 'PARA',
      button: 'Botão',
      external: 'Externo',
      center: 'Centralizado',
      left: 'Esquerda',
      right: 'Direita',
      other: 'Outro',
      option: 'Opção',
    },
    actions: {
      new: 'CRIAR FORMULÁRIO',
      delete: 'Deletar',
      export: 'Exportar',
      report: 'Relatório',
      edit: 'Editar',
      copy: 'Copiar',
      close: 'Fechar',
      cancel: 'Cancelar',
      duplicate: 'Duplicar',
      publish: 'Publicar',
      back: 'Voltar',
      click: 'CLIQUE',
      add: 'ADICIONAR',
    },
  },
  index: {
    title: 'Formulários de Pesquisa',
    subtitle: 'O jeito mais simples e fácil de criar suas pesquisas',
    find_a_box: 'Procurar um Formulário de Pesquisa',
    list_header: {
      modality: 'Modalidad',
      last_modification: 'Última Modificação',
    },
  },
  error: {
    oops: 'oops',
    page_not_exists: 'É possível que essa página não exista...',
    check_url: 'Verifique se o endereço está digitado corretamente ou tente novamente mais tarde',
    something_wrong: 'Algo parece estar errado...',
    system_offline: 'O sistema pode estar fora do ar. ',
    our_devs: 'Mas os nossos técnicos já estão dedicados a resolver esse problema. ',
    try_again_later: 'Tente novamente em instantes',
  },
  modal: {
    cant_export_table: {
      title: 'Não é possível exportar esse relatório',
      max_limit: 'Limite máximo para exportação de resultados são de ',
      select_interval: ' respostas. Por favor, selecione um período de datas menor',
    },
    code: {
      step_one: 'Copie o código do Formulário de Pesquisa abaixo e cole na sua página',
      step_two: 'Copie o código do botão de chamada abaixo ',
      step_three: 'e adicione no link ou botão que abrirá o Formulário de Pesquisa',
    },
    delete_box: {
      are_you_sure: 'Você deseja realmente deletar esse Formulário de Pesquisa?',
      yes: 'Sim, eu quero deletar esse Formulário de Pesquisa!',
    },
    delete_step: {
      are_you_sure: 'Você deseja realmente deletar esse passo?',
      yes: 'Sim, eu quero deletar esse passo!',
    },
    duplicate_step: {
      are_you_sure: 'Você deseja realmente duplicar esse passo?',
      yes: 'Sim, eu quero duplicar esse passo!',
    },
    export_table: {
      answer_table: 'Tabela de Respostas',
      insert: 'Insira abaixo seu email para enviarmos a tabela de respostas quando estiver pronta',
    },
    export_table_in_progress: {
      processing_request: 'solicitação está sendo processada',
      send_email: 'e assim que for finalizada nós enviaremos para o e-mail',
      some_hours: 'Esse processo pode levar algumas horas',
    },
  },
  report: {
    menu: {
      report_of: 'Report de',
      back_to_answers_summary: 'Voltar para resumo de respostas',
      metrics: 'Métricas',
      individual_answers: 'Respostas Individuais',
      box_options: 'Opções do Formulário de Pesquisa',
    },
    charts: {
      total_answers: 'Total de respostas',
    },
    individual: {
      date_filter: 'FILTRAR POR PERÍODO',
      date_range: 'PERÍODO',
      from: 'De',
      to: 'Até',
      answered_in: 'Respondido em',
      obtained_answers: 'respostas obtidas',
    },
    metrics: {
      total_visits: 'VISITAS TOTAIS',
      visits_without_answers: 'VISITAS SEM RESPOSTAS',
      quizzes_not_completed: 'QUIZZES NÃO CONCLUÍDOS',
      quizzes_completed: 'QUIZZES CONCLUÍDOS',
      completion_rate: 'TAXA DE CONCLUSÃO',
      average_time_to_complete: 'TEMPO MÉDIO PARA CONCLUIR',
      desktop: 'PCs & LAPTOPS',
      tablet: 'tablet',
      mobile: 'celular',
      others: 'outros',
    },
    emails: {
      captured_emails: 'e-mails capturados',
      who_answered: 'de quem respondeu',
    },
    resume: {
      question_not_answered: 'Essa pergunta ainda não possui uma resposta',
      no_information_found: 'Nenhuma informação encontrada',
    },
  },
  edit: {
    canvas: {
      visualizing: 'Visualizando',
      active_item: 'Item Ativo',
      default_item: 'Item Padrão',
      past_item: 'Item passado',
      progressbar: 'Barra de Progresso',
      general_styles: 'Estilos Gerais',
      answer_options: 'Opções de Resposta',
      redirect_button: 'Botão de Redirecionamento',
      positive_button: 'Botão Posexternalitivo',
      positive_button_text: 'Texto do Botão Positivo',
      negative_button: 'Botão Negativo',
      negative_button_text: 'Texto do Botão Negativo',
      welcome_title: 'Título de Boas Vindas',
      welcome_description: 'Descrição de Boas Vindas',
      welcome_buttons: 'Botões de Boas Vindas',
      welcome_active: 'Ativar Passo de Boas Vindas',
      next_button: 'Botão Próximo',
      question_description: 'Descrição da Pergunta',
      question_description_placeholder: 'Descrição da Chamada',
      question_title: 'Título da Pergunta',
      question_title_placeholder: 'Digite aqui sua pergunta',
      all_steps: 'Todos os Passos',
      mail_service: 'Serviço de Email',
      mail_service_text_area: 'Cole aqui o código HTML do formulário ' +
        'fornecido pelo seu serviço de email',
      custom_html_form: 'Formulário HTML customizado',
      redirect_by_mail_service: 'Redirecionar pelo serviço de email',
      multiple_answers: 'Permitir mais de uma resposta',
      add_other_option: 'Adicionar opção "outra"',
      redirect_url: 'URL de redirecionamento',
      auto_redirect: 'Redirecionamento Automático',
      required_response: 'Resposta obrigatória',
      multiline_response: 'Resposta em múltiplas linhas',
      multiple_choice_placeholder: 'Escreva aqui uma opção de resposta',
      add_option: 'Adicionar Opção',
      button_text: 'Texto do Botão',
      start_button_text: 'Texto do Botão Iniciar',
      next_button_text: 'Texto do Botão Próximo',
      you_are_editing: 'Você está editando o',
      external_button: 'BOTÃO EXTERNO',
      click_button: 'Clique no botão',
      copy_the: 'Copie o',
      box_code: 'código do Formulário de Pesquisa',
      call_button_code: 'código do botão de chamada',
      past_in_your_page: ' e cole na sua página',
      add_to_link_or_button: 'e adicione no link ou botão que abrirá o Formulário de Pesquisa',
      see_flow: 'Ver Fluxo',
      first_value_welcome_select: 'Sim ou Não',
      second_value_welcome_select: 'Iniciar',
    },
    sidebar: {
      interval_until_action: 'Exibir em intervalo de tempo até que o visitante realize a ação',
      times_until_action: 'Exibir limitadas vezes até que o visitante realize a ação',
      until_action: 'Exibir até que o visitante realize a ação',
      display_frequency: 'Frequência de Exibição',
      when_box_should_display: 'Quando o Formulário de Pesquisa deve aparecer?',
      exibition_mode: 'Modo de exibição',
      how_box_should_display: `Em que momento o Formulário de Pesquisa deve aparecer para o
      seu visitante?`,
      when_leave_the_page: 'Ao sair da página',
      immediately_when_access: 'Imediatamente ao acessar',
      on_scroll: 'Na rolagem',
      until_page_top: 'Até começo da página (25%)',
      until_page_middle: 'Até meio da página (50%)',
      until_page_bottom: 'Até final da página (75%)',
      by_time_on_page: 'Por tempo na página',
      call_button_style: 'Estilo do Botão de Chamada',
      background_color: 'Cor de Fundo',
      border_color: 'Cor da Borda',
      border_radius: 'Arredondamento',
      text_color: 'Cor do Texto',
      visibility: 'Visibilidade',
      font: 'Fonte',
      font_size: 'Tamanho do Texto',
      height: 'Altura',
      width: 'Largura',
      add_jump: 'Adicionar Salto',
      add_answer: 'Adicionar resposta',
      select_destiny: 'Selecione um destino',
      all_other_cases: 'Em todos os outros casos ir para...',
      always_jump_to: 'Sempre Saltar para...',
      select_one_answer: 'Selecione uma resposta',
      select_the_answers: 'Selecione as respostas',
      choose_one_answer: 'Escolha uma resposta',
      go_to_next: 'Ir para o próximo',
      add_one_question: 'adicione UMA questão CLICANDO NESTE BOTÃO',
      question: 'pergunta',
      yes_no: 'sim/não',
      text: 'texto',
      capture: 'Captura',
      of_email: 'de e-mail',
      redirec: 'REDIRECIO',
      tion: 'NAMENTO',
      format: 'Formato',
      choose_a_theme: 'ESCOLHA UM MODELO',
      edit_theme: 'Editar tema',
      without_style: 'Sem Estilo',
      alignment: 'Alinhamento',
      call_button: 'Botão de Chamada',
      in_one_component: 'Em um componente',
      one_component_to_integrate: 'Um componente para integrar em sua página',
      in_full_screen: 'Em tela inteira',
      one_screen_that_cover: 'Uma tela cobre a sua página completamente',
      in_mini_slider: 'Em um mini slide',
      one_small_window_apper: 'Uma pequena janela surge no canto inferior da página',
      in_a_popup: 'Em um pop-up',
      one_box_apper_in_the_middle: 'Uma caixa surge no meio da tela',
      in_a_slider: 'Em um slide',
      one_screen_apper_right: 'Uma tela que surge do lado direito',
      how_might_show: 'Como deseja exibir?',
      select_box_format: 'Selecione o formato do seu Formulário de Pesquisa',
      auto: 'Automaticamente',
      at_some_point: 'Em algum momento durante o acesso',
      on_click: 'Ao clicar',
      on_click_some_button: 'Ao clicar em algum botão dentro da página',
      when_might_show: 'Quando deseja exibir?',
      select_when_box_should_apper: 'Selecione quando o Formulário de Pesquisa deve aparecer',
      configure_box: 'Configurar o Formulário de Pesquisa',
    },
  },
  step_kinds: {
    kinds: {
      multiple_choise: {
        title: 'Qual é a sua pergunta?',
        description_text: 'Descrição da pergunta',
      },
      yes_no: {
        title: 'Qual é a sua pergunta?',
        description_text: 'Descrição da pergunta',
      },
      text: {
        title: 'Qual é seu nome?',
        description_text: '',
        placeholder: 'Digite aqui seu nome...',
      },
      email: {
        title: 'Qual é o seu email?',
        description_text: '',
      },
      redirect: {
        title: 'Parabéns! Clique aqui para acessar seu conteúdo personalizado',
        description_text: '',
        button_text: 'Acessar a página',
      },
      thanks: {
        title: 'Obrigado!',
        description_text: 'Seus dados foram computados com sucesso na nossa pesquisa!',
      },
    },
    options: {
      multiple_choise: {
        first_option: 'Opção 1',
        second_option: 'Opção 2',
      },
      yes_no: {
        yes: 'Sim',
        no: 'Não',
      },
    },
  },
  notifications: {
    noNotifications: 'Não há novas notificações.',
    unableLoad: 'Não foi possível carregar as notificações no momento.',
  },
  empty: {
    title: 'Crie formulários para conhecer melhor seus clientes e capturar contatos',
    subtitle: `Você pode realizar pesquisas que te ajudam a entender seu público.
               Ao final do formulário, colete os leads (contatos) das pessoas que responderam.`,
    link: 'Saiba mais sobre formatos de formulários que você pode criar',
    button: 'Criar formulário',
    url: 'https://suporteklickpages.zendesk.com/hc/pt-br/articles/4587915332109-Conhecendo-o-Klickbox',
    urlExtensions: 'https://suporteklickpages.zendesk.com/hc/pt-br/articles/4587915332109-Conhecendo-o-Klickbox',
  },
};



/** WEBPACK FOOTER **
 ** ./src/i18n/messages/languages/ptBR.js
 **/